// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import MainEmail from "./MainEmail";
// import EmailPreview from "../Dashboard/EmailPreview";
// import ReplyEmail from "../Dashboard/ReplyEmail";
// import { API_URL } from "../../config";
// import DashboardLayout from "../../layout/DashboardLayout";

// // Updated API endpoints for email fetching
// const API_ENDPOINTS = {
//   ALL_CATEGORIES: (userId) => `${API_URL}/email/${userId}/categories/all`,
//   DELETE_EMAIL: (userId, accountId, emailId) =>
//     `${API_URL}/email/${userId}/accounts/${accountId}/emails/${emailId}/delete`,
// };

// // Default user data as fallback
// const DEFAULT_USER = {
//   name: "User",
//   email: "",
//   picture: "/default-avatar.svg",
//   isLoading: false,
// };

// // Add axios interceptor to ensure Authorization header is set for all requests
// axios.interceptors.request.use(
//   (config) => {
//     const token = Cookies.get("access_token");
//     if (token) {
//       // Ensure token has Bearer prefix
//       const authToken = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
//       config.headers.Authorization = authToken;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// const EmailSection = () => {
//   const navigate = useNavigate();
//   const { emailId } = useParams();
//   const [accessToken, setAccessToken] = useState(null);
//   const [accountId, setAccountId] = useState(
//     () => localStorage.getItem("current_account_id") || null
//   );
//   const [userId, setUserId] = useState(
//     () => localStorage.getItem("user_id") || null
//   );
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [viewingAllAccounts, setViewingAllAccounts] = useState(
//     () => localStorage.getItem("view_all_accounts") === "true"
//   );
//   const [userData, setUserData] = useState(() => {
//     // Initialize from localStorage on component mount
//     const cachedData = localStorage.getItem("cached_user_data");
//     if (cachedData) {
//       try {
//         const parsedData = JSON.parse(cachedData);
//         return {
//           ...parsedData,
//           isLoading: false,
//         };
//       } catch (e) {
//         console.error("Failed to parse cached user data:", e);
//         return {
//           name: localStorage.getItem("user_name") || DEFAULT_USER.name,
//           email: localStorage.getItem("user_email") || DEFAULT_USER.email,
//           picture: localStorage.getItem("user_picture") || DEFAULT_USER.picture,
//           isLoading: false,
//         };
//       }
//     }
//     return {
//       name: localStorage.getItem("user_name") || DEFAULT_USER.name,
//       email: localStorage.getItem("user_email") || DEFAULT_USER.email,
//       picture: localStorage.getItem("user_picture") || DEFAULT_USER.picture,
//       isLoading: false,
//     };
//   });
//   const [emails, setEmails] = useState(() => {
//     try {
//       const cachedEmailsData = localStorage.getItem("cached_emails");
//       if (cachedEmailsData) {
//         const parsedEmails = JSON.parse(cachedEmailsData);
//         if (
//           parsedEmails.needs_response?.length > 0 ||
//           parsedEmails.spam?.length > 0 ||
//           parsedEmails.notify?.length > 0
//         ) {
//           return parsedEmails;
//         }
//       }
//     } catch (error) {
//       console.error("Error loading cached emails:", error);
//     }

//     // Return default state if no cache or error
//     return {
//       needs_response: [],
//       spam: [],
//       notify: [],
//       pagination: {
//         total_count: 0,
//         total_pages: 0,
//         has_more: false,
//         category_counts: {
//           needs_response: 0,
//           spam: 0,
//           notify: 0,
//         },
//       },
//     };
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [activeCategory, setActiveCategory] = useState("needs_response");
//   const [emailsPerPage, setEmailsPerPage] = useState(25);
//   const [selectedEmail, setSelectedEmail] = useState(null);
//   const [isReplying, setIsReplying] = useState(false);
//   // Track last forced refresh time to prevent excessive refreshes
//   const [lastForceRefreshTime, setLastForceRefreshTime] = useState(() => {
//     const stored = localStorage.getItem("last_force_refresh_time");
//     return stored ? parseInt(stored, 10) : 0;
//   });
//   // Add a flag to prevent multiple simultaneous deletes
//   const [isDeletingEmail, setIsDeletingEmail] = useState(false);

//   // Check token and set initial state on mount
//   useEffect(() => {
//     // Set access token
//     const token = Cookies.get("access_token");
//     if (token) {
//       setAccessToken(token);
//     } else {
//       navigate("/");
//       return;
//     }

//     // Load cached emails immediately
//     loadCachedEmails();

//     // Initial fetch of emails - limit force refresh
//     const shouldForceRefresh = shouldPerformForceRefresh();
//     if (userId) {
//       fetchEmails(shouldForceRefresh);
//       // If we did a force refresh, update the timestamp
//       if (shouldForceRefresh) {
//         updateForceRefreshTimestamp();
//       }
//     }
//   }, [navigate]);

//   // Function to determine if we should perform a force refresh
//   const shouldPerformForceRefresh = () => {
//     const now = Date.now();
//     // Only allow force refresh once every 10 minutes (600,000 ms)
//     const MIN_REFRESH_INTERVAL = 10 * 60 * 1000;
//     return now - lastForceRefreshTime > MIN_REFRESH_INTERVAL;
//   };

//   // Function to update the force refresh timestamp
//   const updateForceRefreshTimestamp = () => {
//     const now = Date.now();
//     setLastForceRefreshTime(now);
//     localStorage.setItem("last_force_refresh_time", now.toString());
//   };

//   const handleEmailSelect = (email) => {
//     if (selectedEmail && selectedEmail.email.id === email.email.id) {
//       setSelectedEmail(null);
//       navigate("/email");
//     } else {
//       setSelectedEmail(email);
//       navigate(`/email/reply/${email.email.id}`);
//     }
//   };

//   const handleBackToInbox = () => {
//     setSelectedEmail(null);
//     setIsReplying(false);
//     navigate("/email");
//   };

//   useEffect(() => {
//     // Find selected email in the current emails if emailId is provided
//     if (emailId && emails) {
//       const categories = ["needs_response", "spam", "notify"];
//       for (const category of categories) {
//         const foundEmail = emails[category]?.find(
//           (e) => e.email.id === emailId
//         );
//         if (foundEmail) {
//           setSelectedEmail(foundEmail);
//           return;
//         }
//       }
//     }
//   }, [emailId, emails]);

//   const handleReply = () => {
//     setIsReplying(true);
//   };

//   const handleCloseReply = () => {
//     setIsReplying(false);
//   };

//   const handleAccountChange = (account) => {
//     if (account === null) {
//       // All accounts selected
//       setAccountId(null);
//       setViewingAllAccounts(true);
//       localStorage.setItem("view_all_accounts", "true");
//       console.log("Switching to view all accounts");
//     } else if (account && account.id) {
//       setAccountId(account.id);
//       setViewingAllAccounts(false);
//       localStorage.setItem("view_all_accounts", "false");
//       localStorage.setItem("current_account_id", account.id);
//       console.log(`Switching to specific account: ${account.id}`);
//     }

//     // Reset state
//     setEmails({
//       needs_response: [],
//       spam: [],
//       notify: [],
//       pagination: {
//         total_count: 0,
//         total_pages: 0,
//         has_more: false,
//         category_counts: {
//           needs_response: 0,
//           spam: 0,
//           notify: 0,
//         },
//       },
//     });
//     setSelectedEmail(null);

//     // Account change is significant enough to justify a force refresh
//     // But still check if we're not refreshing too frequently
//     const shouldForce = shouldPerformForceRefresh();

//     // Fetch emails after a small delay to ensure state updates
//     setTimeout(() => {
//       if (userId) {
//         console.log(
//           `Fetching emails after account change with force=${shouldForce}`
//         );
//         fetchEmails(shouldForce);
//         if (shouldForce) {
//           updateForceRefreshTimestamp();
//         }
//       }
//     }, 0);
//   };

//   // Load cached emails function
//   const loadCachedEmails = () => {
//     try {
//       const cachedEmailsData = localStorage.getItem("cached_emails");
//       if (cachedEmailsData) {
//         const parsedEmails = JSON.parse(cachedEmailsData);
//         // Only set emails if we have data in any category
//         if (
//           parsedEmails.needs_response?.length > 0 ||
//           parsedEmails.spam?.length > 0 ||
//           parsedEmails.notify?.length > 0
//         ) {
//           setEmails((prevEmails) => ({
//             ...prevEmails,
//             ...parsedEmails,
//             pagination: parsedEmails.pagination || prevEmails.pagination,
//           }));
//         }
//       }
//     } catch (error) {
//       console.error("Error loading cached emails:", error);
//     }
//   };

//   // Add visibility change handler to refresh emails when tab becomes visible
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === "visible") {
//         // Check token validity
//         const token = Cookies.get("access_token");
//         if (!token) {
//           navigate("/");
//           return;
//         }

//         // Refresh emails if it's been more than 5 minutes
//         const lastFetchTime = localStorage.getItem("emails_last_fetch");
//         if (lastFetchTime) {
//           const now = Date.now();
//           const lastFetch = new Date(lastFetchTime).getTime();
//           const timeSinceLastFetch = now - lastFetch;

//           if (timeSinceLastFetch > 5 * 60 * 1000) {
//             // Only use false here - we don't need force refresh on visibility change
//             fetchEmails(false);
//           }
//         }
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);

//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, [navigate]);

//   // Updated fetchEmails function with new API endpoint
//   const fetchEmails = useCallback(
//     async (forceRefresh = false) => {
//       console.log("fetchEmails called with forceRefresh:", forceRefresh);

//       if (!userId) {
//         console.error("No user ID available");
//         setLoading(false);
//         return;
//       }

//       if (loading) {
//         console.log("Already fetching emails, skipping...");
//         return;
//       }

//       setLoading(true);
//       setError(null);

//       // Use the new endpoint format for all emails
//       const endpoint = API_ENDPOINTS.ALL_CATEGORIES(userId);
//       console.log("Fetching emails from endpoint:", endpoint);

//       let abortController = new AbortController();

//       try {
//         // Check cache first if not forcing refresh
//         if (!forceRefresh) {
//           const cachedEmailsData = localStorage.getItem("cached_emails");
//           const lastFetchTime = localStorage.getItem("emails_last_fetch");

//           if (cachedEmailsData && lastFetchTime) {
//             const cacheAge = (new Date() - new Date(lastFetchTime)) / 1000;
//             if (cacheAge < 300) {
//               // 5 minutes cache
//               console.log("Using cached email data");
//               const parsedEmails = JSON.parse(cachedEmailsData);

//               if (
//                 parsedEmails &&
//                 Array.isArray(parsedEmails.needs_response) &&
//                 Array.isArray(parsedEmails.spam) &&
//                 Array.isArray(parsedEmails.notify)
//               ) {
//                 // Calculate actual counts from cached data
//                 const counts = {
//                   needs_response: parsedEmails.needs_response.length,
//                   spam: parsedEmails.spam.length,
//                   notify: parsedEmails.notify.length,
//                 };

//                 setEmails({
//                   ...parsedEmails,
//                   pagination: {
//                     ...parsedEmails.pagination,
//                     category_counts: counts,
//                   },
//                 });
//                 setLoading(false);
//                 return;
//               }
//             }
//           }
//         }

//         // Make API request with the new format
//         const response = await axios.get(endpoint, {
//           params: {
//             force_refresh: forceRefresh,
//           },
//           signal: abortController.signal,
//           withCredentials: true,
//         });

//         if (response.data) {
//           // Process the response - extracting from accounts structure
//           let formattedData = {
//             needs_response: [],
//             spam: [],
//             notify: [],
//             pagination: {
//               total_count: 0,
//               total_pages: 0,
//               has_more: false,
//               category_counts: {
//                 needs_response: 0,
//                 spam: 0,
//                 notify: 0,
//               },
//             },
//           };

//           // Process the new accounts-based structure
//           if (
//             response.data.accounts &&
//             typeof response.data.accounts === "object"
//           ) {
//             Object.entries(response.data.accounts).forEach(
//               ([accountId, accountEmails]) => {
//                 // Process each category of emails for this account
//                 ["needs_response", "spam", "notify"].forEach((category) => {
//                   if (Array.isArray(accountEmails[category])) {
//                     // Transform emails to include account information
//                     const processedEmails = accountEmails[category].map(
//                       (emailData) => ({
//                         email: {
//                           id: emailData.id,
//                           thread_id: emailData.thread_id,
//                           subject: emailData.subject,
//                           body: emailData.body,
//                           body_text: emailData.body_text,
//                           from_name: emailData.from_name,
//                           from_email: emailData.from_email,
//                           date: emailData.date,
//                           send_time: emailData.send_time,
//                           provider: "gmail", // Assuming default provider
//                           is_read: emailData.is_read,
//                         },
//                         account: {
//                           id: accountId,
//                           email: emailData.from_email,
//                           provider: "gmail", // Default provider
//                         },
//                       })
//                     );

//                     // Add to the appropriate category
//                     formattedData[category] = [
//                       ...formattedData[category],
//                       ...processedEmails,
//                     ];
//                   }
//                 });
//               }
//             );
//           }

//           // Update counts
//           formattedData.pagination.category_counts = {
//             needs_response: formattedData.needs_response.length,
//             spam: formattedData.spam.length,
//             notify: formattedData.notify.length,
//           };

//           formattedData.pagination.total_count =
//             formattedData.needs_response.length +
//             formattedData.spam.length +
//             formattedData.notify.length;

//           // Only cache if we have data
//           if (
//             formattedData.needs_response.length > 0 ||
//             formattedData.spam.length > 0 ||
//             formattedData.notify.length > 0
//           ) {
//             localStorage.setItem(
//               "cached_emails",
//               JSON.stringify(formattedData)
//             );
//             localStorage.setItem("emails_last_fetch", new Date().toISOString());
//           }

//           setEmails(formattedData);
//           setError(null);
//         }
//       } catch (err) {
//         console.error("Error fetching emails:", err);
//         if (!axios.isCancel(err)) {
//           if (
//             err.response?.status === 404 &&
//             err.response?.data?.detail === "No authenticated accounts found"
//           ) {
//             setError(
//               "No authenticated accounts found. Please connect an email account."
//             );
//           } else {
//             setError("Failed to fetch emails. Please try again.");
//           }

//           // Try to use cached data as fallback
//           try {
//             const cachedData = localStorage.getItem("cached_emails");
//             if (cachedData) {
//               const parsedData = JSON.parse(cachedData);
//               if (
//                 parsedData &&
//                 Array.isArray(parsedData.needs_response) &&
//                 Array.isArray(parsedData.spam) &&
//                 Array.isArray(parsedData.notify)
//               ) {
//                 setEmails(parsedData);
//               }
//             }
//           } catch (e) {
//             console.error("Error using cached data as fallback:", e);
//           }
//         }
//       } finally {
//         setLoading(false);
//       }

//       return () => {
//         abortController.abort();
//       };
//     },
//     [userId, loading]
//   );

//   // Updated handleDeleteEmail function with new API endpoint and optimized email state handling
//   const handleDeleteEmail = async (emailId) => {
//     // Prevent multiple simultaneous delete operations
//     if (isDeletingEmail) {
//       toast.info("Already processing a delete operation");
//       return false;
//     }

//     setIsDeletingEmail(true);

//     try {
//       console.log("Attempting to delete email:", emailId);

//       // Create a copy of the current emails state for optimistic updates
//       const currentEmails = { ...emails };

//       // Find the email in all categories
//       const categories = ["needs_response", "spam", "notify"];
//       let emailToDelete = null;
//       let foundCategory = null;

//       for (const category of categories) {
//         emailToDelete = currentEmails[category]?.find(
//           (email) => email.email.id === emailId
//         );
//         if (emailToDelete) {
//           foundCategory = category;
//           break;
//         }
//       }

//       if (!emailToDelete) {
//         console.error("Email not found in current state");
//         toast.error("Email not found. Try refreshing the page.");
//         return false;
//       }

//       // Get the account ID from the email data
//       const emailAccountId =
//         viewingAllAccounts && emailToDelete.account
//           ? emailToDelete.account.id
//           : accountId;

//       if (!emailAccountId) {
//         throw new Error("Cannot determine account ID for email");
//       }

//       // Normalize provider name
//       let provider = (emailToDelete.email.provider || "gmail").toLowerCase();
//       if (provider === "google") {
//         provider = "gmail";
//       }

//       // Optimistically update UI first
//       setEmails((prevEmails) => ({
//         ...prevEmails,
//         [foundCategory]: prevEmails[foundCategory].filter(
//           (e) => e.email.id !== emailId
//         ),
//         pagination: {
//           ...prevEmails.pagination,
//           total_count: prevEmails.pagination.total_count - 1,
//           category_counts: {
//             ...prevEmails.pagination.category_counts,
//             [foundCategory]:
//               prevEmails.pagination.category_counts[foundCategory] - 1,
//           },
//         },
//       }));

//       // If the deleted email was selected, clear the selection and navigate back
//       if (selectedEmail?.email.id === emailId) {
//         setSelectedEmail(null);
//         navigate("/email");
//       }

//       // Use the new delete endpoint
//       await axios.delete(
//         API_ENDPOINTS.DELETE_EMAIL(userId, emailAccountId, emailId),
//         {
//           params: {
//             provider: provider,
//           },
//           withCredentials: true,
//         }
//       );

//       // Update the local storage cache to match current state
//       const updatedEmails = {
//         ...currentEmails,
//         [foundCategory]: currentEmails[foundCategory].filter(
//           (e) => e.email.id !== emailId
//         ),
//         pagination: {
//           ...currentEmails.pagination,
//           total_count: currentEmails.pagination.total_count - 1,
//           category_counts: {
//             ...currentEmails.pagination.category_counts,
//             [foundCategory]:
//               currentEmails.pagination.category_counts[foundCategory] - 1,
//           },
//         },
//       };

//       localStorage.setItem("cached_emails", JSON.stringify(updatedEmails));

//       toast.success("Email deleted successfully");
//       return true;
//     } catch (error) {
//       console.error("Failed to delete email:", error);
//       toast.error("Failed to delete email");

//       // If deletion fails, refresh emails from cache (not from server)
//       loadCachedEmails();
//       return false;
//     } finally {
//       setIsDeletingEmail(false);
//     }
//   };

//   const handleSidebarStateChange = (collapsed) => {
//     setIsSidebarCollapsed(collapsed);
//   };

//   const handleCategoryChange = (category) => {
//     console.log(`Switching to category: ${category}`);
//     setActiveCategory(category);
//     // No API call needed - we already have all categories in memory
//   };

//   // Function to manually refresh emails (user triggered)
//   const handleManualRefresh = () => {
//     // For manual refreshes, we can allow force refresh if it's been long enough
//     const shouldForce = shouldPerformForceRefresh();
//     fetchEmails(shouldForce);
//     if (shouldForce) {
//       updateForceRefreshTimestamp();
//       toast.info("Performing full refresh from email server");
//     } else {
//       toast.info("Refreshing from recent cache");
//     }
//   };

//   return (
//     <>
//       <DashboardLayout>
//         {isReplying ? (
//           <div className="w-full">
//             <ReplyEmail
//               email={selectedEmail}
//               onClose={handleCloseReply}
//               userId={userId}
//               accountId={accountId}
//               accessToken={accessToken}
//               isReplying={isReplying}
//             />
//           </div>
//         ) : (
//           <>
//             <div className="font-bold text-[24px] flex justify-between items-center text-[#1F9BFF] px-6 py-2">
//               <h1>Email</h1>
//               <button
//                 onClick={handleManualRefresh}
//                 disabled={loading}
//                 className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md"
//               >
//                 {loading ? "Refreshing..." : "Refresh"}
//               </button>
//             </div>
//             <div className="flex w-full h-[calc(100vh-4rem)]">
//               <div
//                 className={`h-full transition-all duration-300 ${
//                   selectedEmail && !isReplying ? "w-[60%]" : "w-full"
//                 }`}
//               >
//                 <MainEmail
//                   emails={emails}
//                   activeCategory={activeCategory}
//                   loading={loading}
//                   error={error}
//                   emailsPerPage={emailsPerPage}
//                   onEmailSelect={handleEmailSelect}
//                   onCategoryChange={handleCategoryChange}
//                   onFetchEmails={handleManualRefresh}
//                   setActiveCategory={setActiveCategory}
//                   onDelete={handleDeleteEmail}
//                   email={selectedEmail}
//                   viewingAllAccounts={viewingAllAccounts}
//                 />
//               </div>

//               {selectedEmail && !isReplying ? (
//                 <div className="w-[40%] h-[calc(100vh-7rem)]">
//                   <EmailPreview
//                     email={selectedEmail}
//                     onBack={handleBackToInbox}
//                     onReply={() => {
//                       setIsReplying(true);
//                     }}
//                     onDelete={handleDeleteEmail}
//                   />
//                 </div>
//               ) : null}
//             </div>
//           </>
//         )}
//       </DashboardLayout>
//     </>
//   );
// };

// export default EmailSection;

import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainEmail from "./MainEmail";
import EmailPreview from "../Dashboard/EmailPreview";
import ReplyEmail from "../Dashboard/ReplyEmail";
import DashboardLayout from "../../layout/DashboardLayout";
import { useEmails } from "../../providers/EmailsContext";

// Default user data as fallback
const DEFAULT_USER = {
  name: "User",
  email: "",
  picture: "/default-avatar.svg",
  isLoading: false,
};

const EmailSection = () => {
  const navigate = useNavigate();
  const { emailId } = useParams();
  const [accessToken, setAccessToken] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [userData, setUserData] = useState(() => {
    // Initialize from localStorage on component mount
    const cachedData = localStorage.getItem("cached_user_data");
    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);
        return {
          ...parsedData,
          isLoading: false,
        };
      } catch (e) {
        console.error("Failed to parse cached user data:", e);
        return {
          name: localStorage.getItem("user_name") || DEFAULT_USER.name,
          email: localStorage.getItem("user_email") || DEFAULT_USER.email,
          picture: localStorage.getItem("user_picture") || DEFAULT_USER.picture,
          isLoading: false,
        };
      }
    }
    return {
      name: localStorage.getItem("user_name") || DEFAULT_USER.name,
      email: localStorage.getItem("user_email") || DEFAULT_USER.email,
      picture: localStorage.getItem("user_picture") || DEFAULT_USER.picture,
      isLoading: false,
    };
  });

  // Initialize selectedEmail from sessionStorage if available
  const [selectedEmail, setSelectedEmail] = useState(() => {
    try {
      const storedEmail = sessionStorage.getItem("selected_email");
      if (storedEmail) {
        const parsedEmail = JSON.parse(storedEmail);
        if (parsedEmail && parsedEmail.email && parsedEmail.email.id) {
          console.log(
            "Restored selected email from sessionStorage:",
            parsedEmail.email.id
          );
          return parsedEmail;
        }
      }
      return null;
    } catch (e) {
      console.error("Error retrieving selected email from sessionStorage:", e);
      return null;
    }
  });

  const [isReplying, setIsReplying] = useState(false);
  const [isDeletingEmail, setIsDeletingEmail] = useState(false);

  // Get emails data from context
  const {
    emails,
    loading,
    error,
    activeCategory,
    handleCategoryChange,
    fetchEmails,
    deleteEmail,
    viewingAllAccounts,
    accountId,
    handleAccountChange,
  } = useEmails();

  console.log("The emails are", emails);

  // Check token on mount
  useEffect(() => {
    // Set access token
    const token = Cookies.get("access_token");
    if (token) {
      setAccessToken(token);
    } else {
      navigate("/");
      return;
    }
  }, [navigate]);

  const handleEmailSelect = (email) => {
    console.log("Email selected:", email.email.id);
    if (selectedEmail && selectedEmail.email.id === email.email.id) {
      setSelectedEmail(null);
      sessionStorage.removeItem("selected_email");
      navigate("/email");
    } else {
      setSelectedEmail(email);
      // Store the selected email in sessionStorage for persistence
      try {
        sessionStorage.setItem("selected_email", JSON.stringify(email));
      } catch (e) {
        console.error("Failed to store selected email in sessionStorage:", e);
      }
      navigate(`/email/reply/${email.email.id}`);
    }
  };

  const handleBackToInbox = () => {
    setSelectedEmail(null);
    sessionStorage.removeItem("selected_email");
    setIsReplying(false);
    navigate("/email");
  };

  useEffect(() => {
    // Find selected email in the current emails if emailId is provided
    if (emailId && emails) {
      const categories = ["needs_response", "spam", "notify"];
      let foundEmail = null;

      // First try to find the email in our current state
      for (const category of categories) {
        foundEmail = emails[category]?.find((e) => e.email.id === emailId);
        if (foundEmail) {
          console.log(`Found email ${emailId} in ${category} category`);
          setSelectedEmail(foundEmail);
          try {
            sessionStorage.setItem(
              "selected_email",
              JSON.stringify(foundEmail)
            );
          } catch (e) {
            console.error(
              "Failed to store selected email in sessionStorage:",
              e
            );
          }
          return;
        }
      }

      // If not found in current state, try localStorage
      if (!foundEmail) {
        console.log(
          `Email ${emailId} not found in state, checking localStorage`
        );
        try {
          const cachedEmailsData = localStorage.getItem("cached_emails");
          if (cachedEmailsData) {
            const parsedEmails = JSON.parse(cachedEmailsData);

            for (const category of categories) {
              foundEmail = parsedEmails[category]?.find(
                (email) => email.email.id === emailId
              );
              if (foundEmail) {
                console.log(`Found email ${emailId} in localStorage cache`);
                setSelectedEmail(foundEmail);
                try {
                  sessionStorage.setItem(
                    "selected_email",
                    JSON.stringify(foundEmail)
                  );
                } catch (e) {
                  console.error(
                    "Failed to store selected email in sessionStorage:",
                    e
                  );
                }
                return;
              }
            }
          }
        } catch (cacheError) {
          console.error("Error checking cache for email:", cacheError);
        }
      }

      // If still not found, log it
      if (!foundEmail) {
        console.log(`Email ${emailId} not found in state or cache`);
        toast.error("Email not found. It may have been deleted.");
      }
    }
  }, [emailId, emails]);

  const handleReply = () => {
    setIsReplying(true);
  };

  const handleCloseReply = () => {
    setIsReplying(false);
  };

  // Wrapper around context's deleteEmail to handle UI state
  const handleDeleteEmail = async (emailId) => {
    // Prevent multiple simultaneous delete operations
    if (isDeletingEmail) {
      toast.info("Already processing a delete operation");
      return false;
    }

    setIsDeletingEmail(true);

    try {
      console.log("Attempting to delete email:", emailId);

      // Call the context's deleteEmail method
      const success = await deleteEmail(emailId);

      if (success) {
        // If the deleted email was selected, clear the selection and navigate back
        if (selectedEmail?.email.id === emailId) {
          setSelectedEmail(null);
          sessionStorage.removeItem("selected_email");
          navigate("/email");
        }

        toast.success("Email deleted successfully");
        return true;
      } else {
        toast.error("Failed to delete email");
        return false;
      }
    } catch (error) {
      console.error("Failed to delete email:", error);
      toast.error(
        `Failed to delete email: ${error.message || "Unknown error"}`
      );
      return false;
    } finally {
      setIsDeletingEmail(false);
    }
  };

  const handleSidebarStateChange = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
  };

  // Function to manually refresh emails (user triggered)
  const handleManualRefresh = () => {
    fetchEmails(1, activeCategory, true);
    toast.info("Refreshing emails...");
  };

  console.log("The selected emails is:", selectedEmail);

  return (
    <>
      <DashboardLayout>
        {isReplying ? (
          <div className="w-full">
            <ReplyEmail
              email={selectedEmail}
              onClose={handleCloseReply}
              userId={localStorage.getItem("user_id")}
              accountId={accountId}
              accessToken={accessToken}
              isReplying={isReplying}
            />
          </div>
        ) : (
          <>
            <div className="font-bold text-[24px] flex justify-between items-center text-[#1F9BFF] px-6 py-2">
              <h1>Email</h1>
            </div>
            <div className="flex w-full h-[calc(100vh-4rem)]">
              <div
                className={`h-full transition-all duration-300 ${
                  selectedEmail && !isReplying ? "w-[60%]" : "w-full"
                }`}
              >
                <MainEmail
                  emails={emails}
                  activeCategory={activeCategory}
                  loading={loading}
                  error={error}
                  emailsPerPage={10}
                  onEmailSelect={handleEmailSelect}
                  onCategoryChange={handleCategoryChange}
                  onFetchEmails={handleManualRefresh}
                  setActiveCategory={handleCategoryChange}
                  onDelete={handleDeleteEmail}
                  email={selectedEmail}
                  viewingAllAccounts={viewingAllAccounts}
                />
              </div>

              {selectedEmail && !isReplying ? (
                <div className="w-[40%] h-[calc(100vh-7rem)]">
                  <EmailPreview
                    email={selectedEmail}
                    onBack={handleBackToInbox}
                    onReply={() => {
                      setIsReplying(true);
                    }}
                    onDelete={handleDeleteEmail}
                  />
                </div>
              ) : null}
            </div>
          </>
        )}
      </DashboardLayout>
    </>
  );
};

export default EmailSection;
